export default "__VITE_ASSET__BWV0N9ps__"